<template>

<div>

    <div class="list-loader-outer">
        <transition name="loader-fade">
            <div class="list-loader" v-if="loading">
                <div class="loader"></div>
            </div>
        </transition>
    </div>

    <h1>Abonnemang
        <a href="/subscriptions/create" class="btn btn-default btn-sm">
          Lägg till abonnemang
        </a>
    </h1>

    <div class="searchbar">

        <form>

            <div class="block freetext" v-bind:class="{ active: search.text != '' && search.text != null }">
                <input class="form-control" v-on:keyup="updateQuery()" v-model="search.text" placeholder="Sök på namn eller arbetsnamn" />
            </div>

            <div class="block" v-bind:class="{ active: search.status != null }">
                <label>
                    <select v-model="search.status" v-on:change="updateQuery()">
                        <option v-bind:value="undefined">Abonnemangsform</option>
                    </select>
                </label>
            </div>

            <div class="block" v-bind:class="{ active: search.status != null }">
                <label>
                    <select v-model="search.status" v-on:change="updateQuery()">
                        <option v-bind:value="undefined">Längd</option>
                    </select>
                </label>
            </div>

            <div class="block" v-bind:class="{ active: search.contract_internal == 1 }">
                <label>
                    <input type="checkbox" v-on:change="updateQuery()" v-model="search.contract_internal" /> Mottagning
                </label>
            </div>

            <div class="block" v-bind:class="{ active: search.contract_external == 1 }">
                <label>
                    <input type="checkbox" v-on:change="updateQuery()" v-model="search.contract_external" /> Företag
                </label>
            </div>

            <a data-toggle="modal" data-target="#myModal" class="btn btn-sm btn-default pull-right">
                <i class="fa fa-file" aria-hidden="true"></i> Spara excel
            </a>

            <br clear="all">

        </form>

    </div>

</div>

</template>

<script>

export default {
    props: {
        query: {
            required: true
        },
        loading: {}
    },
    data: function () {
        return {
            search: {
                text: ''
            }
        }
    },
    methods: {
        updateQuery: function () {
            this.$emit('search', this.search)
        }
    },
    watch: {
        query: function () {
            this.search = this.query
        }
    }
}

</script>
